const onSuccessGetDocument = (data) => {
  const { downloadUrl } = data;
  window.location = downloadUrl;
};

export default onSuccessGetDocument;
